export default __webpack_public_path__ + "static/media/locationsSquare.197cf954.svg";